/** Тонкая обёртка над Telegram Mini App SDK. Вне Telegram всё — no-op. */
interface TgWebApp {
  initData: string;
  initDataUnsafe: { start_param?: string; user?: { first_name?: string } };
  colorScheme: "light" | "dark";
  ready(): void;
  expand(): void;
  setHeaderColor(c: string): void;
  setBackgroundColor(c: string): void;
  disableVerticalSwipes?(): void;
  BackButton: { show(): void; hide(): void; onClick(cb: () => void): void; offClick(cb: () => void): void };
  HapticFeedback?: { impactOccurred(s: "light" | "medium" | "soft"): void };
  onEvent(e: string, cb: () => void): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TgWebApp };
  }
}

export function telegram(): TgWebApp | null {
  const wa = window.Telegram?.WebApp;
  return wa && wa.initData ? wa : null;
}

export function initTelegram(onBack: () => void): void {
  const wa = telegram();
  if (!wa) return;
  document.documentElement.dataset.platform = "telegram";
  wa.ready();
  wa.expand();
  wa.disableVerticalSwipes?.();
  // цвета шапки Telegram выставляет applyTheme(); здесь только подписка на смену темы Telegram
  wa.onEvent("themeChanged", () => void import("./theme").then((m) => m.applyTheme()));
  wa.BackButton.onClick(onBack);
}

export function setTelegramBack(visible: boolean): void {
  const wa = telegram();
  if (!wa) return;
  if (visible) wa.BackButton.show();
  else wa.BackButton.hide();
}

export function haptic(): void {
  telegram()?.HapticFeedback?.impactOccurred("soft");
}

/** Deep link: t.me/<bot>/<app>?startapp=play_<setId> */
export function startParam(): string | null {
  return telegram()?.initDataUnsafe.start_param ?? null;
}
